import {CommonModule} from "@angular/common";
import {Type} from "@angular/compiler";
import {Component, HostListener, Input, OnDestroy, OnInit} from "@angular/core";
import {
    AbstractControl,
    FormArray,
    FormControl,
    FormGroup,
    FormSubmittedEvent,
    NgForm,
    ReactiveFormsModule,
    ValidationErrors,
    Validators
} from "@angular/forms";
import {ShowValidationOptions} from "../../lead-component.component";
import {filter} from "rxjs";

@Component({
    selector: "app-formselect",
    imports: [CommonModule, ReactiveFormsModule],
    standalone: true,
    templateUrl: "./formselect.component.html",
    styleUrl: "./formselect.component.scss"
})
export class FormSelectComponent implements OnInit, OnDestroy {
    @Input() Class: string[] = ["form-select", "form-select-sm"];
    @Input({alias: "a-formcontrol"}) FormControl!: FormControl<string | number | null>; //since it's required and typed we can safely assume a value must be passed in.
    @Input({alias: "a-formcontrol-name"}) FormControlName?: string;
    @Input({alias: "a-validation-messages"}) ValidationMessages?: {validationName: string; validationMessage: string}[];
    formGroup: Partial<typeof this.FormControl.parent> = null;
    formSubmitted: boolean = false;
    constructor() {}
    ngOnDestroy(): void {
    }
    ngOnInit(): void {
        if (!(this.FormControl instanceof FormControl)) {
            throw new Error("a-formcontrol must be an instance of FormControl");
        }

        this.FormControl.events.pipe(filter((event) => event instanceof FormSubmittedEvent)).subscribe((event) => {
            this.formSubmitted = true;
        });

        this.formGroup = this.FormControl.parent;
    }
}

export type DataList = {
    id: string | number;
    label: string;
    value: string | number | Date;
};
